import ButtonComponent from "../../../../components/ButtonComponent";

function RecuperacaoSenha({ closeModal, sendCode, loading }) {
  return (
    <div style={{ flexDirection: "column", display: "flex" }}>
      <span style={styles.title}>Recuperação de senha</span>
      <span style={styles.description}>
        Vamos enviar um código de 6 dígitos no seu celular.
      </span>

      <div
        style={{
          marginTop: 40,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <button style={styles.buttonTertiary} onClick={() => closeModal(false)}>
          Fechar
        </button>

        <ButtonComponent disabled={loading} onClick={() => sendCode()}>
          Continuar
        </ButtonComponent>
      </div>
    </div>
  );
}

const styles = {
  title: {
    fontSize: 18,
    fontWeight: "600",
  },
  description: {
    fontSize: 14,
  },
  buttonTertiary: {
    border: "none",
    background: "transparent",
    fontWeight: "600",
    textDecorationLine: "underline",
    cursor: "pointer",
    color: "#191919",
  },
};

export default RecuperacaoSenha;
